var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIconb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin-socials-social-media-icon-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.129,
    height: 31.129,
    viewBox: "0 0 31.129 31.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43829",
    "data-name": "Path 43829",
    d: "M30.035,7H15.094A8.094,8.094,0,0,0,7,15.094V30.035a8.094,8.094,0,0,0,8.094,8.094H30.035a8.094,8.094,0,0,0,8.094-8.094V15.094A8.094,8.094,0,0,0,30.035,7Zm6.848,23.035a6.848,6.848,0,0,1-6.848,6.848H15.094a6.848,6.848,0,0,1-6.848-6.848V15.094a6.848,6.848,0,0,1,6.848-6.848H30.035a6.848,6.848,0,0,1,6.848,6.848Z",
    transform: "translate(-7 -7)",
    fill: "#111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43830",
    "data-name": "Path 43830",
    d: "M18.981,25H14.623a.623.623,0,0,0-.623.623V39.942a.623.623,0,0,0,.623.623h4.358a.623.623,0,0,0,.623-.623V25.623A.623.623,0,0,0,18.981,25Zm-.623,14.319H15.245V26.245h3.113Z",
    transform: "translate(-9.642 -13.794)",
    fill: "#111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43831",
    "data-name": "Path 43831",
    d: "M35.961,24.994h0A8.828,8.828,0,0,0,31.6,26.307v-.691a.623.623,0,0,0-.623-.623H26.623a.623.623,0,0,0-.623.623V39.936a.623.623,0,0,0,.623.623h4.358a.623.623,0,0,0,.623-.623V30.479a4.769,4.769,0,0,1,1.868-.5c1.749,0,1.868,1.245,1.868,1.519v8.442a.623.623,0,0,0,.623.623h4.358a.623.623,0,0,0,.623-.623V30.08a5.167,5.167,0,0,0-1.332-3.8A4.937,4.937,0,0,0,35.961,24.994ZM39.7,39.313H36.584v-7.82a2.8,2.8,0,0,0-3.113-2.764,6.375,6.375,0,0,0-2.77.8.623.623,0,0,0-.342.554v9.227H27.245V26.239h3.113v1.283a.623.623,0,0,0,1.033.467,7.664,7.664,0,0,1,4.57-1.749h0a3.735,3.735,0,0,1,2.752.915A3.991,3.991,0,0,1,39.7,30.08Z",
    transform: "translate(-14.171 -13.787)",
    fill: "#111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43832",
    "data-name": "Path 43832",
    d: "M16.8,14a2.8,2.8,0,1,0,2.8,2.8A2.8,2.8,0,0,0,16.8,14Zm0,4.358A1.556,1.556,0,1,1,18.358,16.8,1.556,1.556,0,0,1,16.8,18.358Z",
    transform: "translate(-9.642 -9.642)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconb);
export default __webpack_public_path__ + "static/media/linkedin-iconb.37c57d30cc8ae5dee6b7ef643603401a.svg";
export { ForwardRef as ReactComponent };